import { Component, Input, SimpleChanges } from '@angular/core';
import { getRandomColorWithOpacity, wrapLabel, yAxisformateValue } from '@piqet-angular/data';
import { commonEnum, reportTitals } from '@piqet-angular/shared';
import { bottom } from '@popperjs/core';
import { Chart, ChartOptions } from 'chart.js';

@Component({
  selector: 'piqet-angular-report-bar-chart-ingredient',
  templateUrl: './report-bar-chart-ingredient.component.html',
  styleUrls: ['./report-bar-chart-ingredient.component.scss'],
})
export class ReportBarChartIngredientComponent {
  chartOpacity: any = { value: commonEnum.opacity };
  indicatorsName: string = '';
  generatedChartType: string = 'column';
  @Input() impactItems: any;
  chartId: any;
  reportResource = reportTitals;
  barChartData: any = [];
  mbarChartLabels: string[] = [];
  componentItemsArray: any;
  @Input() isIsoReport = false;
  ngOnChanges(changes: SimpleChanges) {
    this.impactItems = changes['impactItems'].currentValue;
    this.chartId = 'BarChartContainer' + this.impactItems.reportTypeId;
    this.componentItemsArray = this.impactItems.componentItems;
    this.chartOpacity = { value: this.impactItems?.opacity };
    this.indicatorsName = this.impactItems?.indicatorName;
  }

  splitterFunc(input: any) {
    return input.includes(';') ? input.split(';') : [input];
  }
}
